var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"paginator",attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 50, 100],"page-size":_vm.perPage,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.collectionTotal},on:{"size-change":_vm.setPageSize,"current-change":_vm.setCurrentPage}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459c4a5b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator.vue
// module id = null
// module chunks = 